import React from "react";
import PropTypes from 'prop-types';

export default class Icon extends React.PureComponent {
    render() {
        let { className, img } = this.props;
        return (
            <img{...this.props} alt={className} className={'icon ' + className} src={img}/>
        );
    }
}

Icon.propTypes = {
    className: PropTypes.string,
    img: PropTypes.node.isRequired,
};
